var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMudgard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 92,
    viewBox: "0 0 160 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 75C155 76.6382 154.286 78.2252 151.498 79.9294C148.518 81.7514 143.774 83.2622 137.193 84.3835C124.106 86.6134 105.777 87 85 87C64.2817 87 45.9364 86.3663 32.8508 84.0162C26.2665 82.8337 21.4814 81.2921 18.4633 79.4841C15.5697 77.7508 15 76.2604 15 75C15 36.3401 46.3401 5 85 5C123.66 5 155 36.3401 155 75Z",
    stroke: "#D9D9D9",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 75,
    width: 150,
    height: 17,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7303,
    y: 70,
    width: 7,
    height: 21,
    rx: 2,
    transform: "rotate(48.5091 15.7303 70)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMudgard);
export default __webpack_public_path__ + "static/media/Mudgard.4d1e211b59d57fe17a4cd66c17e59a6c.svg";
export { ForwardRef as ReactComponent };